module.exports = __webpack_public_path__ + "static/img/11.6a333ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/11.png
// module id = qvdq
// module chunks = 1